import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Contact from './pages/Contact';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import Header from './components/HeaderComponents/Header';
import Loader from './components/Loader';
import { useEffect, useState } from "react";
import './App.css';

function App() {
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    setTimeout(() => setLoading(false), 2000); // simulate API
  }, []);

  if (loading) return <Loader />;
  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />      {/* Home page */}
        <Route path="/about" element={<About />} /> {/* About page */}
         <Route path="/services" element={<Services />} /> {/* Service page */}
         <Route path="/contact" element={<Contact />} /> {/* About page */}
      </Routes>
    </Router>
  );
}

export default App;
